const SIZE_BASE = 1024,
    SIZE_PRECISION = 2,
    SIZE_UNITS = ['byte', 'kib', 'mib', 'gib', 'tib', 'pib', 'eib'],
    SPEED_UNITS = ['byteps', 'kibps', 'mibps', 'gibps', 'tibps', 'pibps', 'eib'];

class SharedHelperService {
    constructor($window, $filter) {
        this.$window = $window;
        this.$filter = $filter;
    }

    expressBytes(bytes, showSpeed, showUnits = true) {
        if (bytes < 0) return;
        const size = this.fromBytes(bytes, showSpeed);
        return `${size.value} ${showUnits ? this.$filter('translate')(`common.unit.default.size.${size.unit}`) : ''}`;
    }

    fromBytes(bytes, showSpeed = false, precision = SIZE_PRECISION) {
        if (bytes === 0) return { value: 0, unit: showSpeed ? SPEED_UNITS[0] : SIZE_UNITS[0] };
        let i = Math.floor(Math.log(bytes) / Math.log(SIZE_BASE));

        return {
            value: parseFloat((bytes / Math.pow(SIZE_BASE, i)).toFixed(precision)),
            unit: showSpeed ? SPEED_UNITS[i] : SIZE_UNITS[i]
        };
    }

    /** checkIfIE IE fn - returns version of IE or false, if browser is not Internet Explorer */
    checkIfIE() {
        let ua = this.$window.navigator.userAgent;
        // IE 10// ua = 'Mozilla/5.0 (compatible; MSIE 10.0; Windows NT 6.2; Trident/6.0)';
        // IE 11// ua = 'Mozilla/5.0 (Windows NT 6.3; Trident/7.0; rv:11.0) like Gecko';
        // Edge 12 (Spartan)// ua = 'Mozilla/5.0 (Windows NT 10.0; WOW64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/39.0.2171.71 Safari/537.36 Edge/12.0';
        // Edge 13// ua = 'Mozilla/5.0 (Windows NT 10.0; Win64; x64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/46.0.2486.0 Safari/537.36 Edge/13.10586';
        let msie = ua.indexOf('MSIE ');
        if (msie > 0) {
            // IE 10 or older => return version number
            return parseInt(ua.substring(msie + 5, ua.indexOf('.', msie)), 10);
        }
        let trident = ua.indexOf('Trident/');
        if (trident > 0) {
            // IE 11 => return version number
            let rv = ua.indexOf('rv:');
            return parseInt(ua.substring(rv + 3, ua.indexOf('.', rv)), 10);
        }
        let edge = ua.indexOf('Edge/');
        if (edge > 0) {
            // Edge (IE 12+) => return version number
            return parseInt(ua.substring(edge + 5, ua.indexOf('.', edge)), 10);
        }
        // other browser
        return false;
    }

    converMilisecToDate(input, locale, format, timezone) {
        const date = moment.utc(input);
        if (new Date(input).getFullYear() >= 2020) {
            //custom handle of years after 2020, because moment don't calculate well summer time after 2020 year
            let date = new Date(input);
            return `${date.toLocaleDateString(locale).replace(/ /g, '')} ${date.toLocaleTimeString([locale], { hour: '2-digit', minute: '2-digit' })}`;
        } else {
            return date.locale(locale).tz(timezone).format(format);
        }
    }

}
SharedHelperService.$inject = ['$window', '$filter'];

module.exports = SharedHelperService;


// WEBPACK FOOTER //
// ./src/shared/utils/sharedHelper.service.js